import { useCallback, useMemo } from "react";
import { useAccount } from "./useAccount";
import { PremiumInventoryDetails } from "features/types";
import { getUniqSubscriptions } from "utils/subscriptionUtils";

const useMarketingAssetsSections = (planPackageId: number | undefined) => {
  const { account } = useAccount();

  const marketingAssetsSeatGroups = useMemo(() => {
    if (!account || !planPackageId) return [];

    const primaryComponent = getUniqSubscriptions(account.subscriptions).find(
      (sub) => sub.planPackage.id === planPackageId
    )?.planPackage.primaryComponent;

    if (!primaryComponent) return [];

    const { seatGroups } = primaryComponent;
    const marketingAssetsSeatGroups = seatGroups.filter(
      (seatGroup) => seatGroup.marketingAssets
    );
    return marketingAssetsSeatGroups;
  }, [account, planPackageId]);

  const isSectionMarketingAssets = useCallback(
    (section: string) => {
      return marketingAssetsSeatGroups.some((seatGroup) =>
        seatGroup.seatGroupSections.some(
          (seatGroupSection) => seatGroupSection.section === section
        )
      );
    },
    [marketingAssetsSeatGroups]
  );

  const isPremiumInventoryMarketingAssets = (
    premiumInventory: PremiumInventoryDetails | null
  ) => {
    if (!premiumInventory) return false;
    return premiumInventory.premiumCodes.some((premiumCode) =>
      premiumCode.sections.some((section) =>
        isSectionMarketingAssets(section.section)
      )
    );
  };

  return {
    isSectionMarketingAssets,
    isPremiumInventoryMarketingAssets,
  };
};

export default useMarketingAssetsSections;
